/**
 * TeamPrintersView - Combined view for Team Status and Printers
 *
 * Contains two tabs:
 * - Team: Team status and activity
 * - Printers: Printer dashboard
 */

import { useState } from 'react';
import TeamView from '../TeamView';
import PADashboard from '../PADashboard';

// Tab configuration
const TABS = [
  { id: 'team', label: 'Team Status', icon: 'users' },
  { id: 'printers', label: 'Printers', icon: 'printer' },
];

export default function TeamPrintersView({ userEmail, isAdmin }) {
  const [activeTab, setActiveTab] = useState('team');

  // Tab icon renderer
  const renderTabIcon = (iconName) => {
    switch (iconName) {
      case 'users':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        );
      case 'printer':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
          </svg>
        );
      default:
        return null;
    }
  };

  return (
    <div className="min-h-full bg-slate-200 text-gray-900">
      {/* Tab Bar */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4">
          <nav className="flex gap-1">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`
                  flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors
                  ${activeTab === tab.id
                    ? 'border-purple-600 text-purple-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }
                `}
              >
                {renderTabIcon(tab.icon)}
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </div>

      {/* Tab Content */}
      {activeTab === 'team' && (
        <TeamView userEmail={userEmail} isAdmin={isAdmin} />
      )}

      {activeTab === 'printers' && (
        <PADashboard />
      )}
    </div>
  );
}
